import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/grunndata/$systemName/$assetGroupName")({
  beforeLoad: ({ params }) => {
    return {
      getTitle: () => params.assetGroupName,
    };
  },
});
